export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10787.fdc81942.jpg";